export default __webpack_public_path__ + "static/media/CNo.86-0.4f365ef1.jpg";